<span class="cpb-validation-message" *ngIf="validationErrors | async as errors">
  {{ errors[0] }}
</span>
